// extracted by mini-css-extract-plugin
export default {"title":"Rsa-z","warning":"Ssa-z","sizeOptionsLegendText":"Tsa-z"};